import { render, staticRenderFns } from "./DriverEdit.vue?vue&type=template&id=366b0eb4"
import script from "../../controllers/driver/driver-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/driver/driver-edit.js?vue&type=script&lang=js&external"
import style0 from "./DriverEdit.vue?vue&type=style&index=0&id=366b0eb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports